// @flow
import React from "react";

import type { PasswordStrengthType } from "../types/UserFormType";

import CloseIcon from "@material-ui/icons/Close";
import DoneIcon from "@material-ui/icons/Done";

type PasswordStrengthBoxPropType = {
  passwordstrength: PasswordStrengthType,
  password: string
};

export function checkPswStrength(pswStr: PasswordStrengthType, val: string): PasswordStrengthType {
  if (/\d/.test(val)) {
    pswStr["number"] = true;
  }
  else {
    pswStr["number"] = false;
  }
  if (/[a-z]/.test(val)) {
    pswStr["lowercase"] = true;
  }
  else {
    pswStr["lowercase"] = false;
  }
  if (/[A-Z]/.test(val)) {
    pswStr["uppercase"] = true;
  }
  else {
    pswStr["uppercase"] = false;
  }
  if (val.trim().length >= 8) {
    pswStr["length"] = true;
  }
  else {
    pswStr["length"] = false;
  }
  if (/\s/g.test(val)) {
    pswStr["space"] = false;
  }
  else {
    pswStr["space"] = true;
  }

  return pswStr;
}

export const PasswordStrengthBox = (props: PasswordStrengthBoxPropType): * => {
  if (Object.values(props.passwordstrength).includes(false) && props.password !== "") {
    return (
      <div className="pswd_info">
        <h4>Password Rules:</h4>
        <ul>
          <li className={props.passwordstrength.length ? "valid" : "invalid"}>{props.passwordstrength.length ? <DoneIcon className="tiny-icon" /> : <CloseIcon className="tiny-icon" />}At least <strong>8 Characters</strong></li>
          <li className={props.passwordstrength.uppercase ? "valid" : "invalid"}>{props.passwordstrength.uppercase ? <DoneIcon className="tiny-icon" /> : <CloseIcon className="tiny-icon" />}At least <strong>one uppercase letter</strong></li>
          <li className={props.passwordstrength.lowercase ? "valid" : "invalid"}>{props.passwordstrength.lowercase ? <DoneIcon className="tiny-icon" /> : <CloseIcon className="tiny-icon" />}At least <strong>one lowercase letter</strong></li>
          <li className={props.passwordstrength.number ? "valid" : "invalid"}>{props.passwordstrength.number ? <DoneIcon className="tiny-icon" /> : <CloseIcon className="tiny-icon" />}At least <strong>one number</strong></li>
          <li className={props.passwordstrength.space ? "valid" : "invalid"}>{props.passwordstrength.space ? <DoneIcon className="tiny-icon" /> : <CloseIcon className="tiny-icon" />}No <strong>whitespace</strong></li>
        </ul>
      </div>
    );
  }
  else {
    return null;
  }
};
 